




















































import { Vue, Component, Prop } from "vue-property-decorator";

import { InputTypes, SimpleInput as Simple, TextArea } from "@netex/inputs";

import PageTitle from "@/components/common/PageTitle.vue";
import { IPrice, IPriceSend } from "@/services/interfaces";
import { pricesModule } from "@/plugins/store-accessors";

enum DataProps {
  title = "title",
  margin = "margin",
  rounding = "rounding",
}

interface IValidationField {
  value: string | number;
  errorMessage: string;
}

interface InputSchema {
  type: string;
  component: string;
  name: string;
  required?: boolean;
  placeholder?: string;
  title?: string;
  inputType?: string;
  prefix?: string;
  mask?: IValidationField;
  regex?: IValidationField;
  min?: IValidationField;
  max?: IValidationField;
}

interface InputElement extends Element {
  checkForErrors: () => boolean;
  checkForValid: () => void;
}

interface Payload {
  [DataProps.title]: string;
  [DataProps.margin]: string;
  [DataProps.rounding]: string;
}

@Component({
  components: {
    Simple,
    PageTitle,
  },
})
export default class PriceTypeForm extends Vue {
  @Prop({ type: Function, default: () => null })
  readonly sendData!: (data: IPriceSend) => Promise<any>;

  @Prop({ type: Number, default: 0 })
  readonly id!: number;

  error: boolean = false;
  success: string = "";
  inputFields: InputSchema[] = [
    {
      component: "input-simple",
      type: "text",
      name: "title",
      required: true,
      title: "Название",
    },
    {
      component: "input-simple",
      type: "number",
      name: "margin",
      required: true,
      title: "Наценка",
    },
  ];

  inputData: Payload = {
    [DataProps.title]: "",
    [DataProps.margin]: "",
    [DataProps.rounding]: "0",
  };

  roundingOptions = [
    {
      title: "Не округлять",
      value: 0,
    },
    {
      title: "До 1 рубля",
      value: 1,
    },
    {
      title: "До 10 рублей",
      value: 10,
    },
    {
      title: "До 100 рублей",
      value: 100,
    },
  ];

  content = {
    message: "Добавить тип цены",
  };

  getInput(type: InputTypes) {
    switch (type) {
      case InputTypes.TEXT:
        return TextArea;
      default:
        return Simple;
    }
  }

  getDataValue(name: string) {
    const data = pricesModule.getPrices;
    const value = data.find((item) => item.id === this.id);
    if (value) {
      return value[name as DataProps].toString();
    }

    return "";
  }

  async submit() {
    if (!this.errorCheck()) {
      try {
        const res = await this.sendData({ id: this.id, ...this.inputData });
      } catch (err) {
        this.error = true;
        console.warn(err);
      }
    }
  }

  errorCheck() {
    const errors: boolean[] = [];
    const refs = Object.keys(this.$refs);
    refs.forEach((ref) => {
      (this.$refs[ref] as InputElement[])[0].checkForValid();
      const error = (this.$refs[ref] as InputElement[])[0].checkForErrors();
      if (error) errors.push(error);
    });
    return errors.length;
  }

  setValue(str: DataProps, val: string) {
    const data = Object.assign({}, this.inputData);
    data[str] = val;
    this.inputData = data;
  }

  setSelect(event: any) {
    const name = event.target.name as DataProps;
    const value = event.target.value;
    const data = Object.assign({}, this.inputData);
    data[name] = value;
    this.inputData = data;
  }

  mounted() {
    const data = this.getDataValue("rounding");
    this.inputData[DataProps.rounding] = data || "0";
  }
}
